// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthLayout_container__rakHy","content":"AuthLayout_content__3YRab"};